import { FC } from 'react'

import { useDispatch } from 'react-redux'

import { useAppSelector } from 'src/Hooks/redux'
import {
  getDismissedUpsellCampaignIds,
  setDismissedUpsellCampaignId,
} from 'src/Redux/alert-process'

import { CampaignUpsellCard } from './CampaignUpsellCard'
import { CampaignUpsellProps } from './CampaignUpsellCard/helpers'

export const CampaignUpsell: FC<CampaignUpsellProps> = (props) => {
  const { campaignId, onUpsellMetaAds, onOpenIntercom, onRelaunch } = props
  const dispatch = useDispatch()
  const dismissedIds = useAppSelector(getDismissedUpsellCampaignIds)

  if (campaignId && dismissedIds.includes(campaignId)) {
    return null
  }

  const dismiss = (): void => {
    if (campaignId) {
      dispatch(setDismissedUpsellCampaignId(campaignId))
    }
  }

  return (
    <CampaignUpsellCard
      {...props}
      onUpsellMetaAds={() => {
        onUpsellMetaAds()
        dismiss()
      }}
      onOpenIntercom={(message) => {
        onOpenIntercom(message)
        dismiss()
      }}
      onRelaunch={(isCTA) => {
        onRelaunch(isCTA)
        dismiss()
      }}
    />
  )
}
